import { forwardRef } from "react";
import SvgIcon from "@mui/material/SvgIcon";
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDistribution = forwardRef((props, ref) => {
	return React.createElement(SvgIcon, {
		...props,
		ref
	}, /* @__PURE__ */ _jsx("path", {
		d: "M0.6875 0.6875V21.3125H21.3125",
		fill: "none",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12.9708 15.9115C13.3202 16.4943 13.7838 17.0004 14.3339 17.3992L14.9875 17.875",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M3.4375 17.875L4.09108 17.3992C4.68636 16.9725 5.17921 16.4186 5.53388 15.7777C5.88856 15.1369 6.09617 14.4251 6.14167 13.6941L6.50833 7.29666C6.55758 6.61595 6.8649 5.97974 7.36751 5.51802C7.87012 5.05631 8.53006 4.80394 9.2125 4.8125H9.33808",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8.38751 17.875L9.0411 17.3992C9.63638 16.9725 10.1292 16.4186 10.4839 15.7777C10.8386 15.1369 11.0462 14.4251 11.0917 13.6941L11.4583 7.29666C11.5076 6.61595 11.8149 5.97974 12.3175 5.51802C12.8201 5.05631 13.4801 4.80394 14.1625 4.8125C14.8457 4.80276 15.5068 5.0546 16.0104 5.51643C16.514 5.97827 16.822 6.61515 16.8713 7.29666L17.2379 13.6941C17.2829 14.4247 17.4898 15.1362 17.8437 15.7771C18.1975 16.4179 18.6895 16.972 19.2839 17.3992L19.9375 17.875",
		fill: "none",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}));
});
export default SvgDistribution;
